import { EmployeeLiteModel } from 'api-hooks/employee';
import { PurchaseModel } from 'api-hooks/order/common';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// export class OrderAdjustmentPurchaseModel {
//   id: string;
//   agent: string;
//   code: string;
//   description: string;
//   number: string;
//   status: string;

//   @Expose({ name: 'payment_channel' })
//   paymentChannel: string;

//   @Expose({ name: 'transaction_at' })
//   @Type(() => Date)
//   transactionAt: Date;

//   @Expose({ name: 'transaction_type' })
//   transactionType: string;
// }

export class OrderAdjustmentLiteModel extends CommonModel {
  status: TransactionalStatusEnum;
  description: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Type(() => PurchaseModel)
  purchase: PurchaseModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class OrderAdjustmentModel extends OrderAdjustmentLiteModel {
  number: string;
}

//Query

export type getOrderAdjustmentsInput = {
  params: CommonParamInput & {
    status?: string;
  };
};
export type getOrderAdjustmentInput = {
  id: string;
};

//Mutation
export type OrderAdjustmentMutationInput = object;

export type OrderAdjustmentMutationUpdate = {
  id: string;
  body: OrderAdjustmentMutationInput;
};

export type OrderAdjustmentMutationVoid = {
  id: string;
};

export type OrderAdjustmentMutationDelete = {
  id: string;
};
